import http from 'plugins/axios';

export default {

    kline(data) {
        return http.post({
            url: '/admin/trade/cache/kline',
            data,
            dataType: 'form'
        })
    },
    order(data) {
        return http.post({
            url: '/admin/trade/cache/order',
            data,
            dataType: 'form'
        })
    }
};
